<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "usersWrapper"
};
</script>

<style scoped></style>
